import { API_URL } from "../config/api";

export async function createRegistration() {
  const response = await fetch(
    `${API_URL}/registration`,
    {
      method: "POST",
    }
  );

  return response.json();
}

export async function getRegistration(
  registrationCode: string
) {
  const response = await fetch(
    `${API_URL}/registration/${registrationCode}`
  );

  return response.json();
}